/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon20Regular = forwardRef('LogoTwitterIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.681 4.24a.75.75 0 0 0-1.135-.98L10.72 7.69l-3.237-4.28c-.195-.259-.5-.41-.824-.41H4.32c-.854 0-1.34.976-.825 1.657l4.595 6.077-4.34 5.025a.75.75 0 1 0 1.135.98l4.13-4.782 3.502 4.632c.195.258.5.41.825.41h2.336c.854 0 1.34-.976.825-1.658l-4.86-6.427 4.037-4.675ZM13.575 15.5l-8.317-11h1.168l8.317 11h-1.168Z" })));
});
